import rootMessages from "@/client/locale/he-IL/messages";

let messages = {};

export default utilities.mergeObjects(rootMessages, messages);
